import {
    ChangeDetectionStrategy,
    Component,
    effect,
    ElementRef,
    input,
    output,
    viewChild,
    ViewEncapsulation,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { getErrorMessage, RouterLinkDirective } from '@hyundai/ng-common-lib';
import { InputTextComponent, M020C060InputCheckboxComponent } from '@hyundai/ui';
import { WidgetInstance } from 'friendly-challenge';
import { derivedAsync } from 'ngxtension/derived-async';
import { startWith } from 'rxjs';
import { DistributionForm } from '../distribution-overview-step/distribution-overview-step.component';

@Component({
    selector: 'lib-distribution-contact-template',
    standalone: true,
    templateUrl: './distribution-contact-template.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [InputTextComponent, M020C060InputCheckboxComponent, ReactiveFormsModule, RouterLinkDirective],
})
export default class DistributionContactTemplateComponent {
    form = input.required<FormGroup<DistributionForm>>();
    valueChanges = derivedAsync(() => {
        const c = this.form();
        return c.valueChanges.pipe(startWith(c.value));
    });
    friendlyCaptcha = viewChild<ElementRef<HTMLElement>>('frccaptcha');
    formClicked = output();
    submitClicked = output();
    errorMsg = input<string>();
    getErrorMessage = getErrorMessage;

    constructor() {
        effect(() => {
            const el = this.friendlyCaptcha()?.nativeElement;
            if (this.friendlyCaptcha() && el) {
                const widget = new WidgetInstance(el, {
                    doneCallback: (solution) => {
                        this.form().get('captchaSolution')?.patchValue(solution);
                        this.form().updateValueAndValidity();
                    },
                    errorCallback: (b) => {
                        console.error('error', b);
                        this.form().get('captchaSolution')?.patchValue('');
                        this.form().updateValueAndValidity();
                    },
                });
                widget.start();
            }
        });
    }
}
